<template>
  <div class="menuFrame">
    <article class="indexMargin">
      <div class="contentBox">
        <div class="PcDevice">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h1 class="display-4">歡迎使用參展商管理系統</h1>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-center">
            <div class="lead my-4">請先選擇您要管理的報名表：</div>
            <div>
              <span class="bold">登入帳號 :</span>
              <span> {{ UserId }}</span>
            </div>
          </div>
        </div>
        <div class="MbDevice">
          <p class="mb-2 ml-1" style="font-size: 13px; margin-top: 10px">
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </p>
          <hr />
          <div class="font-weight-light h1">歡迎使用參展商管理系統</div>
          <div class="mt-3 mb-3 lead">請先選擇您要管理的報名表：</div>
        </div>
        <hr />

        <p class="my-3">&nbsp;</p>
        <div v-show="hasExh">
          <ul v-for="item in ExhibitionList" class="mx-5 my-3">
            <li>
              <div class="row justify-content-between align-items-center">
                <div class="col-sm-8 text-sm-left text-center">
                  <div class="lineStyle align-items-center">
                    <div class="mr-sm-5">
                      <img
                        :src="`//www.ccie.com.tw/exhibition/images/exlogo/${item.ExhLogo}`"
                        class="img-fluid imgSize"
                      />
                    </div>
                    <div>
                      <p class="bold mb-1" style="font-size: 18px">{{ item.Exhibition }}</p>
                      <span>
                        <p class="gray">{{ item.ExhBegin }} ~ {{ item.ExhEnd }}</p>
                        <p class="gray">{{ item.ExhVenue }}</p>
                        <p class="divider">&nbsp;</p>
                        <p>
                          <span class="colorBG">{{ item.AppNo }}</span> {{ item.Directory_ComName }}
                        </p>
                        <p>展覽分區 : {{ item.ExhibArea }}</p>
                        <p>
                          攤位號碼 :
                          <span v-if="item.BoothNo == 'N/A'"> - </span>
                          <span v-else> {{ item.BoothNo }} </span>
                        </p>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-4 text-right PcDevice">
                  <div v-if="item.Del == 'c'">
                    <div class="btn btn-lg btn-primary" @click.prevent="ExhibitionHome(item.RegNo)">管理</div>
                  </div>

                  <div v-else-if="item.Del == 'd'">
                    <button type="button" class="btn btn-lg btn-secondary" disabled>退展審核中</button>
                  </div>
                </div>
                <div class="col-sm-4 mb-2 text-center MbDevice">
                  <div v-if="item.Del == 'c'">
                    <div class="btn btn-primary" @click.prevent="ExhibitionHome(item.RegNo)">管理</div>
                  </div>
                  <div v-else-if="item.Del == 'd'">
                    <button type="button" class="btn btn-secondary" disabled>退展審核中</button>
                  </div>
                </div>
              </div>
            </li>
            <hr />
          </ul>
        </div>
        <div v-show="!hasExh" style="font-size: 21px" class="pb-5 pt-4">
          您並非參展商，或是尚未被授予參展商管理權限，若有任何問題歡迎與我們<a
            href="https://www.chanchao.com.tw/contact.asp"
            target="_blank"
            >聯絡</a
          >。
        </div>
      </div>
    </article>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    components: {},

    data() {
      return {
        ExhibitionList: [],
        UserId: '',
        hasExh: true,
      }
    },

    metaInfo() {
      return {
        title: '展覽列表 - 展昭參展商管理系統',
      }
    },
    methods: {
      ExhibitionHome(id) {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/home?no=${id}`
      },
    },

    created() {
      const vm = this

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition?lang=tw`).then((response) => {
        // console.log(response)

        if (response.data.Code == 200) {
          vm.ExhibitionList = response.data.Data
          vm.hasExh = true
        } else if (response.data.Code == 404) {
          vm.hasExh = false
          // console.log('查無資料')
        } else {
          alert('系統忙線中，請稍後再試')
        }
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })
    },
  }
</script>

<style lang="scss">
  .colorBG {
    background-color: #eee;
    display: inline;
    padding: 2px 5px;
  }

  .imgSize {
    width: 180px;
  }

  .lineStyle {
    display: flex;
  }

  @media (max-width: 501px) {
    .lineStyle {
      display: block;
      margin-bottom: 25px;
    }

    .imgSize {
      width: 100px;
      margin-bottom: 15px;
    }
  }
</style>
